<div class="modal-used-days">
  <app-loader *ngIf="isLoading"></app-loader>
  <div class="modal-content-used-days" *ngIf="!isLoading">
      <div (click)="closeModalUsedDays()" class="close-icon"> <i class="lni lni-close"></i></div>
      <h3 class="modal-title">Uvid u iskorišćene slobodne dane</h3>
      <div *ngFor="let yearData of absenceDaysByYear | keyvalue" class="year-data">
          <div class="year-header">Godina: {{ yearData.key }}</div>
          <div *ngFor="let holiday of yearData.value" class="holiday-info">
              <div class="holiday-date">Početak: {{ holiday.start_date.date | date:'dd.MM.yyyy' }}</div>
              <div class="holiday-date">Kraj: {{ holiday.end_date.date | date:'dd.MM.yyyy' }}</div>
              <div class="holiday-link margin-top-10"><a [routerLink]="['/zahtjev-pregled', holiday.holiday_id]">Pogledaj zahtjev</a></div>
              <div class="holiday-days margin-top-10" *ngIf="!holiday.hours">Broj iskorišćenih dana: {{ holiday.absence_days }}</div>
              <div class="holiday-days margin-top-10" *ngIf="holiday.hours">Broj iskorišćenih sati i minuta: {{ holiday.hours }}:{{ holiday.minutes }}</div>
          </div>
      </div>
      <div class="modal-footer">
          <button class="btn btn-secondary cancel-button" (click)="closeModalUsedDays()">Zatvori</button>
      </div>
  </div>
</div>
